import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Users } from './users.model';
import { usersInfoBuilderUI } from './users.mapper';

import { format } from '@shared/utilities/formatEmail';

import { environment } from '@env/environment';
const baseUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(private _http: HttpClient) {}

  getUserInfo(username: string): Observable<Users> {
    return this._http
      .get(`${baseUrl}/users/${format(username)}/user-info`)
      .pipe(map(usersInfoBuilderUI));
  }

  getInvestorInfo(username: string): Observable<any> {
    return this._http.get(
      `${baseUrl}/users/${format(username)}/investor-profile`
    );
  }

  updateInvestorInfo(username: string, data): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/investor-profile`,
      data
    );
  }

  getInvestorPhoto(username: string): Observable<any> {
    return this._http.get(
      `${baseUrl}/users/${format(username)}/investor-profile/photo`
    );
  }

  uploadInvestorPhoto(username: string, fileToUpload: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    return this._http.post(
      `${baseUrl}/users/${format(username)}/investor-profile/photo`,
      formData
    );
  }

  checkResetToken(username, token): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/check-reset-token`,
      {
        token
      }
    );
  }

  resetPassword(username, token, newPassword): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/reset-password`,
      {
        token,
        newPassword
      }
    );
  }

  getAccess(): Observable<any> {
    return this._http.get(`${baseUrl}/access`, { responseType: 'text' });
  }

  checkUserForPreOrder(username, propertyId): Observable<any> {
    return this._http.get(
      `${baseUrl}/users/${format(username)}/allow-pre-order/${propertyId}`
    );
  }

  confirmEmail(username, data): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/change-email-confirmation`,
      data
    );
  }
}
